module.exports = __webpack_public_path__ + "img/芒果10.db09963b.png";